import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'pkp-g-object-management',
  imports: [RouterOutlet],
  template: `<router-outlet></router-outlet>`,
})
export class ObjectManagementPage {}
